import React, { useEffect, useRef, useState } from "react";
import InputBox from "../../../business-types/grocery/components/InputBox";
import { Button } from "src/business-types/grocery/components/Button";

type BarcodeScannerProps = {
  onDetected: (result: string) => void;
};

const SCAN_TIMEOUT = 50; // ms (scanner speed)

const BarcodeScanner: React.FC<BarcodeScannerProps> = ({ onDetected }) => {
  const [manualCode, setManualCode] = useState("");
  const bufferRef = useRef("");
  const lastKeyTimeRef = useRef<number>(0);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement;

      // ⛔ Ignore typing inside inputs
      if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") {
        return;
      }

      const now = Date.now();

      // ⏱ Reset buffer if typing is slow (human typing)
      if (now - lastKeyTimeRef.current > SCAN_TIMEOUT) {
        bufferRef.current = "";
      }

      lastKeyTimeRef.current = now;

      if (e.key === "Enter") {
        const code = bufferRef.current.trim();
        if (code.length > 3) {
          onDetected(code);
        }
        bufferRef.current = "";
        return;
      }

      // ✅ Accept only valid barcode characters
      if (/^[a-zA-Z0-9]$/.test(e.key)) {
        bufferRef.current += e.key;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onDetected]);

  const handleManualSubmit = () => {
    if (manualCode.trim()) {
      onDetected(manualCode.trim());
      setManualCode("");
    }
  };

  return (
    <div className='flex flex-col items-center gap-2 m-2'>
      <div className='flex items-center gap-2'>
        <InputBox
          type='text'
          placeholder='Enter barcode manually'
          value={manualCode}
          onChange={(e) => setManualCode(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleManualSubmit()}
        />
        <Button label='Submit' onClick={handleManualSubmit} />
      </div>
    </div>
  );
};

export default BarcodeScanner;
